/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitImageListByCompanyId,
    PressKitImageListByCompanyIdFromJSON,
    PressKitImageListByCompanyIdFromJSONTyped,
    PressKitImageListByCompanyIdToJSON,
} from './PressKitImageListByCompanyId';

/**
 * 
 * @export
 * @interface GetPressKitImageListResponse
 */
export interface GetPressKitImageListResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitImageListResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitImageListResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitImageListByCompanyId}
     * @memberof GetPressKitImageListResponse
     */
    data: PressKitImageListByCompanyId;
}

export function GetPressKitImageListResponseFromJSON(json: any): GetPressKitImageListResponse {
    return GetPressKitImageListResponseFromJSONTyped(json, false);
}

export function GetPressKitImageListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitImageListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitImageListByCompanyIdFromJSON(json['data']),
    };
}

export function GetPressKitImageListResponseToJSON(value?: GetPressKitImageListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitImageListByCompanyIdToJSON(value.data),
    };
}

